<template>
  <hr class="horizontal" style="margin: 8px 0" />
  <ServerPickerMini />
  <BoostMethod :dropdown-variant="'primary'" :disable-ids="disabledIds" />
  <hr class="horizontal" style="margin: 8px 0" />

  <div class="d-flex-column justify-start align-start gap-18">
    <label class="t-white font-family-1 regular-l f-w-600">
      {{ $t("dashboard.extra_options") }}
    </label>
    <PriorityPicker />

    <AddOnOptions :keys="keys" />
    <!-- <ExtraGold /> -->
  </div>
  <hr class="horizontal" style="margin: 8px 0" />
</template>

<script setup>
import ServerPickerMini from "../pickers/ServerPickerMini.vue";
import AddOnOptions from "../cart-pickers/AddOnOptions.vue";
import PriorityPicker from "../cart-pickers/PriorityPicker.vue";
import BoostMethod from "../pickers/BoostMethod.vue";
const checkoutStore = useCheckoutStore();
const { getGamePack, getGame } = useGameStore();

const disabledIds = computed(() => {
  if (checkoutStore.getDetails?.desiredRating > 1800) {
    let options = [];
    const remoteControlOption = getGamePack?.pack_options?.find(
      (option) => option.const_title === "remote_control"
    );
    const selfPlayOption = getGamePack?.pack_options?.find(
      (option) => option.const_title === "self_play"
    );
    if (remoteControlOption) {
      options.push(remoteControlOption.id);
    }
    if (selfPlayOption) {
      options.push(selfPlayOption.id);
    }
    return options;
  }

  return [];
});

const keys = computed(() => {
  if (checkoutStore.getDetails?.desiredRating >= 2100) {
    return ["bis_pvp_combat", "add_9_gems", "weekly_pvp_quests"];
  }
  if (checkoutStore.getDetails?.desiredRating >= 1850) {
    return ["conquest_gear", "add_9_gems", "weekly_pvp_quests"];
  }
  return ["honor_gear", "add_9_gems", "weekly_pvp_quests"];
});

watch(keys, () => {
  const depOps = getGamePack.pack_options
    ?.filter((op) =>
      ["bis_pvp_combat", "honor_gear", "conquest_gear"].includes(op.const_title)
    )
    ?.map((op) => op.id);

  checkoutStore.removePackOption({
    optionIds: depOps,
  });
});
</script>
